import { render, staticRenderFns } from "./UploadNoteForm.vue?vue&type=template&id=46a3e635&"
import script from "./UploadNoteForm.vue?vue&type=script&lang=js&"
export * from "./UploadNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports